const operatorSymbolMap = {
  eq: "\u003D",
  ne: "\u2260",
  lt: "\u003C",
  gt: "\u003E",
};

export default operatorSymbolMap;
